// utils/idUtils.js

// Function to generate a UUID-like alphanumeric value
const generateAlphanumericId = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
        const random = (Math.random() * 10) | 0;
        const value = char === 'x' ? random : (random & 0x3) | 0x8;
        return value.toString(10);
    });
};

const encodeId = (id) => {
    return btoa(id); 
};

 
const decodeId = (encodedId) => {
    return atob(encodedId);  
};

export { generateAlphanumericId, encodeId, decodeId };
